import React, { useContext, useEffect } from 'react';
import { CategoryContext } from './CategoryProvider';
import { makeStyles } from '@material-ui/core';
import Chip from '../../../../../../components/Chip/Chip/Chip';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexFlow: 'row wrap',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const List = () => {
  const classes = useStyles();
  const {
    categories,
    loadCategories,
    deleteCategory,
    selectCategory,
  } = useContext(CategoryContext);

  const handleDelete = (catId) => {
    deleteCategory(catId);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <div className={classes.root}>
      {categories?.length ? (
        categories?.map((category) => (
          <Chip
            clickable
            key={category._id}
            label={category?.name}
            onDelete={() => handleDelete(category._id)}
            onClick={() => selectCategory(category)}
            color="primary"
          />
        ))
      ) : (
        <div>نقشی یافت نشد!</div>
      )}
    </div>
  );
};

export default React.memo(List);
